document.addEventListener("DOMContentLoaded", function () {
    const video = document.querySelector("video");
    const button = document.querySelector(".btn-video");
    const buttonImg = document.querySelector(".btn-video img");

    if (button && video && buttonImg) {
        button.addEventListener("click", function () {
            if (video.paused) {
                video.play();
                buttonImg.src = "imgs/icons/pause.png";
            } else {
                video.pause();
                buttonImg.src = "imgs/icons/play.png";
            }
        });
    }
});

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});